exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container {\n  background-color: white;\n  padding: 24px;\n  box-sizing: border-box;\n  border: 1px solid #f4f4f4;\n  display: flex;\n  flex-direction: column;\n  align-items: center; }\n\n.chart_wrapper {\n  max-width: 100%;\n  border: 1px solid #d4d4d4;\n  border-radius: 6px;\n  margin: 24px;\n  overflow: hidden; }\n", ""]);

// exports
